import { render, staticRenderFns } from "./course-layout-component.vue?vue&type=template&id=c8d11e90&"
import script from "./course-layout-component.vue?vue&type=script&lang=ts&"
export * from "./course-layout-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports